import { DocumentMenu } from "./DocumentMenu";

export default DocumentMenu;
